import CustomAccordion from "../../GlobalComponents/CustomAccordion";
import React, {Fragment, useState} from "react";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import CustomTaggable from "../../GlobalComponents/CustomTaggable";
import MemberQuestions from "./MemberQuestions";
import SpecialQuestions from "./SpecialQuestions";
import Box from "@mui/material/Box";

const DynamicSections = (
    {
        fullActInfo
    }
) => {
    const {
        act: {
            title: parentAccTitle,
            id: panelId = null,
            each_member_questions = [],
            special_questions = []
        } = {},
        members = [],
        id: sectionId,
        has_reminders
    } = fullActInfo;
    const [selectActId, setSelectActId] = useState(null);
    const handleAccordionChange = (event, isExpanded) => {
        if (isExpanded) {
            setSelectActId(panelId)
        } else {
            setSelectActId(null)
        }
    };
    return (
        <div style={{ position: "relative" }}>
            <CustomAccordion
                title={parentAccTitle}
                panelId={String(panelId)}
                detailsSX={{ display: "flex", flexWrap: "wrap", gap: "20px" }}
                borderSX={{ border: "1px solid #E3E6EF" }}
                onChange={handleAccordionChange}
                expanded={panelId !== selectActId ? {expanded: false} : {expanded: true}}
            >
                {selectActId === panelId ? (
                    <Stack gap={1} width="100%">
                        <Divider />
                        <SpecialQuestions specialQuestions={special_questions} sectionId={sectionId} actId={panelId} />
                        <Divider />
                        <Typography>Members</Typography>
                        <Typography>
                            a. Please list all employees and management that ever made a sexual comment or conduct towards you.
                        </Typography>
                        <CustomTaggable members={members} sectionId={sectionId}/>
                        <Divider />
                        <MemberQuestions members={members} memberQuestions={each_member_questions} sectionId={sectionId} actId={panelId} />
                    </Stack>
                ) : null}
            </CustomAccordion>
            <Box display="flex" alignItems="center" gap="10px"  position="absolute" top="20px" right="15px">
                <Box display="flex" gap="5px">
                    <Fragment>
                        {!!has_reminders.type_1 && (
                            <Box
                                width="12px"
                                height="12px"
                                borderRadius="12px"
                                sx={{ bgcolor: `accReminder.type_1` }}
                            />
                        )}
                        {!!has_reminders.type_2 && (
                            <Box
                                width="12px"
                                height="12px"
                                borderRadius="12px"
                                sx={{ bgcolor: `accReminder.type_2` }}
                            />
                        )}
                        {!!has_reminders.type_3 && (
                            <Box
                                width="12px"
                                height="12px"
                                borderRadius="12px"
                                sx={{ bgcolor: `accReminder.type_3` }}
                            />
                        )}
                    </Fragment>
                </Box>
            </Box>
        </div>
    )
}

export default DynamicSections;
